import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_data_table = _resolveComponent("oss-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_oss_data_table, {
      headers: _ctx.headers,
      items: _ctx.items,
      striped: true
    }, {
      "item.rule": _withCtx(({ item }) => [
        _createElementVNode("span", null, _toDisplayString(item.rule), 1)
      ]),
      _: 1
    }, 8, ["headers", "items"])
  ]))
}